// 入口文件
import Vue from 'vue'
// // router
import VueRouter from 'vue-router'
// import vue-resource
import VueResource from 'vue-resource'
import router, { constantRoutes, asyncRoutes } from './router'
import './public-path'
// import echarts from 'echarts'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import service, { cancelTokenSource } from '@/utils/request'
import NProgress from 'nprogress' // progress bar
import './styles/element-variables.scss'
import './assets/icon/iconfont.css'
import './styles/variables.scss'

import directive from './directive' // directive
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN' // element-ui lang
import elementBaLocale from 'element-ui/lib/locale/lang/id'
import elementEsLocale from 'element-ui/lib/locale/lang/es'
import enLocale from './lang/en'
import zhLocale from './lang/zh'
import baLocale from './lang/ba'
import esLocale from './lang/es'
import '@/styles/index.scss'
import VueI18n from 'vue-i18n'
import app from './App.vue'
import dayjs from 'dayjs'
// import axios from 'axios'
// import Vuex from 'vuex'
// import * as echarts from 'echarts'
import Cookies from 'js-cookie'
// import '@/permission'
import store from './store'
import { registerGlobComponents } from './components/register'
import FastClick from 'fastclick'
import { setToken } from '@/utils/auth'
import { numFormat, emptyFormat, checkReq } from '@/utils/util'
import { getIntentionTags } from '@/utils/intentionTags/index'
// 注册全局组件
import { Calendar, Picker } from 'vant'
import { funcBeforeEach } from '@/permission'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import '@/utils/global'
import { bindGoogleMaps } from '@/views/Chatbot/teamInbox/func'

if (!window.__POWERED_BY_QIANKUN__) {
  bindGoogleMaps()
}
FastClick.attach(document.body)

ElementUI.Select.props['popperAppendToBody'].default = false
// ElementUI.Tooltip.mixins[0].props['appendToBody'].default = false
// ElementUI.DatePicker.props['appendToBody'].default = false
// import * as fundebug from 'fundebug-javascript'
// import FundebugVue from 'fundebug-vue'
// fundebug.apikey = 'e1dcc07778bc13cc63c75416d7e653f6e527ff627234ce18aff3440ed41b9f99'
registerGlobComponents()
// new FundebugVue(fundebug).installVueErrorHandler(Vue) // Vue 2.x

Vue.use(Calendar)
Vue.use(Picker)
// Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.http.options.root = 'http://vue.studyit.io'

Vue.use(VueI18n)

var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)
Vue.prototype.$dayjs = dayjs
Vue.prototype.$numFormat = numFormat
Vue.prototype.$emptyFormat = emptyFormat
Vue.prototype.$checkReq = checkReq

var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)

window.OldDate = window.Date
var bind = Function.bind
var unbind = bind.bind(bind)
function instantiate(constructor, args) {
  return new (unbind(constructor, null).apply(null, args))()
}

window.Date = (function(Date) {
  Object.setPrototypeOf(MyDate, Date)
  MyDate.prototype = Date.prototype
  return MyDate
  function MyDate() {
    let arg = arguments[0]
    if (issafariBrowser) {
      if (Object.prototype.toString.call(arg) === '[object String]') {
        arguments[0] = arg = arg.replace(/-/g, '/')
        arguments[0] = arg.replace(/T/, ' ')
        console.log(arguments[0])
      }
    }
    return instantiate(Date, arguments)
  }
})(window.OldDate)

if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true
} else {
  Vue.config.devtools = false
}
const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  },
  ba: {
    ...baLocale,
    ...elementBaLocale
  },
  es: {
    ...esLocale,
    ...elementEsLocale
  }
}
export const i18n = new VueI18n({
  locale: Cookies.get('language') || 'en', // 默认语言
  messages
})
Vue.use(ElementUI, {
  size: 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(directive)

// Sentry.init({
//   Vue,
//   dsn: window.location.host === 'calling.airudder.com' ? 'https://6ba9be20cceb4b33b7e4d3f0c088d16d@sentry.airudder.com/12' : 'https://3d69469174dd4cb1a5c4eb8f342f2e15@sentry.airudder.com/11',
//   integrations: [new Integrations.BrowserTracing()],
//   tracesSampleRate: 1.0
// })

// 路由跳转后，页面回到顶部
router.afterEach(() => {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  if (!window.__POWERED_BY_QIANKUN__) {
    for (const [cancelToken, cancel] of cancelTokenSource) {
      cancel(cancelToken) // cancel 正在pending的请求
    }
    NProgress.done() // 结束Progress
  }
})
var vueThat

vueThat = new Vue({
  el: '#calling',
  render: c => c(app),
  router,
  store,
  i18n
})

function render(props = {}) {
  const { container, microWidgetProps } = props
  vueThat = new Vue({
    render: h => h(app),
    router: route,
    store,
    i18n
  }).$mount(container ? container.querySelector('#calling') : '#calling')
  redirectPopup(container)
}

function redirectPopup(container) {
  if (window.__POWERED_BY_QIANKUN__) {
    const whiteList = []
    // 保存原有document.body.appendChild方法
    let originFn = document.body.appendChild.bind(document.body)
    // 重写appendChild方法
    document.body.appendChild = dom => {
      // 根据标记，来区分是否用新的挂载方式
      if (whiteList.includes(dom.className)) {
        container.querySelector('#calling').appendChild(dom)
      } else {
        originFn(dom)
      }
    }
  }
}

// if (!window.__POWERED_BY_QIANKUN__) {
//   render()
// }

let instance = null
let route = null
let originFn = document.body.appendChild.bind(document.body)
export async function bootstrap() {
  console.log('[vue] vue app bootstraped')
}

export async function mount(props) {
  // require('@/permission')
  service.defaults.headers['x-source'] = window.__POWERED_BY_QIANKUN__ ? 'AICC' : ''
  props.onGlobalStateChange((state, prev) => {
    // state: 变更后的状态; prev 变更前的状态
  })
  store.commit('SET_MODE', 'AICC')

  Vue.prototype.$onGlobalStateChange = props.onGlobalStateChange
  Vue.prototype.$globalState = props.globalState
  window.$globalState = props.globalState

  const token = props.globalState.token
  console.info(props.globalState.AICC_ENV, 'props.globalState.AICC_ENV')
  service.defaults.baseURL = props.globalState.AICC_ENV === 'test' ? 'https://internal-calling.airudder.com/' : 'https://calling.airudder.com/'
  window.origin = props.globalState.AICC_ENV === 'test' ? 'https://internal-calling.airudder.com' : 'https://calling.airudder.com'
  let path = window.location.pathname
  path = path.split('/subapp-calling')
  if (path.length > 0) {
    path = path[1]
  }
  console.info([...constantRoutes, asyncRoutes])

  if (token) {
    console.log('[vue] props from main framework', props, token)
    setToken(token)
    service.defaults.headers['Authorization'] = 'Token ' + token

    store.commit('SET_TOKEN', token)

    store
      .dispatch('GetInfo')
      .then(res => {
        console.log('[vue] props from main framework', res)
        // 拉取用户信息
        const { intention_annotate, intention, product_and_permission, company } = res.data.data
        // 获取用户催收、营销、信审业务对应的意向标签
        getIntentionTags(intention_annotate, intention, company)
        store.dispatch('GenerateRoutes', product_and_permission).then(accessRoutes => {
          // 根据roles权限生成可访问的路由表
          console.info('accessRoutes', accessRoutes)
          route = new VueRouter({
            mode: 'history', // require service support
            scrollBehavior: () => ({ y: 0 }),
            routes: constantRoutes,
            base: window.__POWERED_BY_QIANKUN__ ? '/subapp-calling' : ''
            // base: store.getters.mode ? '/aicc' : ''
          })
          // route.addRoutes([...constantRoutes, ...asyncRoutes])
          route.addRoutes(accessRoutes)
          route.beforeEach((to, from, next) => funcBeforeEach(to, from, next))

          // route.options.routes = []
          render(props)

          // 动态添加可访问路由表
          // router.push({
          //   path: path
          // })

          window.addEventListener('AICCRouterChange', e => {
            let path = e.target.location.pathname
            path = path.split('/subapp-calling')
            if (path.length > 0) {
              path = path[1]
            }
            console.info('AICCRouterChange', e.target.location.pathname, e.target.location, 'path', path)
            // router.push({
            //   path: path
            // })
          })

          // window.location.href = '/'
        })
      })
      .catch(err => {
        console.info(err, 'err1', err.response)
      })
  }
}
export async function unmount() {
  // instance.$destroy()
  // instance.$el.innerHTML = ''
  vueThat.$destroy()
  vueThat.$el.innerHTML = ''
  vueThat = null
  route = null
  router.beforeEach((to, from, next) => {})
  // vueThat.router = null
  // vueThat.router.beforeEach = null
  //  route.beforeEach((to, from, next) => {})
  // instance = null
  // router.options.routes = []
  // router.options.routes = []
  // // router.addRoutes([])
  // // router = null
  // document.body.appendChild = originFn
  // store.dispatch('FedLogOut').then(() => {})
  // console.info('zhixing')
  // for (const [cancelToken, cancel] of cancelTokenSource) {
  //   cancel(cancelToken) // cancel 正在pending的请求
  // }
  // NProgress.done() // 结束Progress
}

export default vueThat



// WEBPACK FOOTER //
// ./src/main.js